import '@/styles/globals.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import Head from 'next/head'
import { Geist, Geist_Mono, Instrument_Serif } from 'next/font/google'
import { RouteProgress } from '@/components/generals/route-progress'

const sans = Geist({
    subsets: ['latin']
})

const mono = Geist_Mono({
    subsets: ['latin']
})

const heading = Instrument_Serif({
    subsets: ['latin'],
    weight: '400',
    style: ['normal', 'italic']
})

const fontVariables = `:root{--font-app-sans:${sans.style.fontFamily};--font-app-mono:${mono.style.fontFamily};--font-app-heading:${heading.style.fontFamily}}`

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <div className='h-full font-sans'>
            <Head>
                <style dangerouslySetInnerHTML={{ __html: fontVariables }} />
            </Head>

            {/* Lives here, outside every page, so the loading bar keeps running while the next page loads. */}
            <RouteProgress />

            <Component {...pageProps} />
        </div>
    )
}

export default App
